import React, {useEffect, useState} from "react";
import Select from "react-select";

export const OfficeSelect = ({selectedCompany, onChange, allOfficesOption, currentValue}) => {
    const [isLoading, setIsLoading] = useState(false);
    let [selectOptions, setSelectOptions] = useState([]);
    let [defaultValue, setDefaultValue] = useState(currentValue || allOfficesOption);

    useEffect(() => {
        function parse() {
            let newOptions = [allOfficesOption];

            if (selectedCompany.offices) {
                selectedCompany.offices.forEach(option => {
                    newOptions.push({
                        ...option,
                        value: option.id,
                        label: option.office_name,
                    });
                });
            }

            setSelectOptions(newOptions)
        }

        parse();

        return function () {
            setSelectOptions([]);
        }
    }, [selectedCompany])

    return (
        <Select options={selectOptions}
                value={currentValue || allOfficesOption}
                isLoading={isLoading}
                defaultValue={defaultValue}
                onChange={onChange}
        />
    );
}
